import React from 'react';
import { Route } from 'react-router-dom';

import Drenagem from './drenagem/Drenagem';
import DrenagemLancamento from './drenagem/DrenagemLancamento';
import RelatorioGeral from './drenagem/RelatorioGeral';
import SwitchRouter from 'components/SwitchRouter';
import DescarregamentoHome from './descarregamento/DescarregamentoHome';
import tmpPrint from './descarregamento/tmpPrint';
import VisualizarAfericao from './afericao/visualizarAfericao/Visualizar';
import InserirAfericao from './afericao/inserirAfericao/Afericao';

export default function Routes() {
    return (
        <SwitchRouter>
            <Route exact path="/combustivel/afericao/inserir" component={InserirAfericao} />
            <Route exat path="/combustivel/afericao/analise" component={VisualizarAfericao} />
            <Route
                exact
                path="/combustivel/drenagem/lancamento/:hashid"
                component={DrenagemLancamento}
            />
            <Route exact path="/combustivel/drenagem/relatorio-geral" component={RelatorioGeral} />
            <Route path="/combustivel/drenagem" component={Drenagem} />

            <Route path="/combustivel/tmp-print" component={tmpPrint} />
            <Route path="/combustivel/descarregamento" component={DescarregamentoHome} />
        </SwitchRouter>
    );
}
